import './page-header.scss';
import { bindable, customElement } from 'aurelia';

@customElement('page-header')
@bindable('title')
export class PageHeader {
}
